<style media="screen">
  body{
    font-size: 14px;
  }
</style>
<template>
  <footer class="bk-footer">
      <div class="footer-content min-width-center clearfix">
          <dl class="clearfix">
              <dt style="text-align:left;">网站导航</dt>
              <dd><a href="http://bk.tencent.com/info#news">蓝鲸动态</a></dd>
              <dd><a href="http://bk.tencent.com/info#recruit">招聘信息</a></dd>
              <dd><a href="http://bk.tencent.com/info#laws">法律申明</a></dd>
              <dd><a href="http://bk.tencent.com/info#about">关于我们</a></dd>
              <dd><a href="http://bbs.bk.tencent.com/">蓝鲸论坛</a></dd>
              <dd><a href="http://bk.tencent.com/school_edition/">蓝鲸校园</a></dd>
          </dl>
          <dl class="clearfix">
              <dt style="text-align:left;">蓝鲸客服</dt>
              <dd>客服 QQ：
                  <a href="https://wpa1.qq.com/KziXGWJs?_type=wpa&qidian=true" target="_blank">800802001</a>
              </dd>
              <dd>客服邮箱：
                  <a href="mailto:contactus_bk@tencent.com">contactus_bk@tencent.com</a>
              </dd>
          </dl>
          <div class="qr_code"><img src="../images/common/Qr_code.png" alt="" /></div>
      </div>
      <div class="copy">
          <div class="copy-content min-width-center">
              <img src="../images/common/footer-logo.png" alt="" />
              <div>
                  <p>Copyright &copy; 2012-{{year}} Tencent. All Rights Reserved.  腾讯公司 版权所有</p>
                  <div class="language">
                      简体中文 <span><img src="../images/common/footer-select.png" alt="" /></span>
                      <div class="language-choose">
                          <a href="javascript:;">简体中文</a>
                          <!-- <a href="javascript:;">English</a> -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </footer>
</template>
<script>
export default {
    data () {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style lang="scss">
    @media screen and (max-width:1180px){
        .footer-content {
            >dl {
                margin-left: 100px;
            }
        }
    }
  .bk-footer {
    padding: 0 !important;
    margin-top: 0 !important;
    .footer-content {
        font-size: 14px;
    }
    .copy-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// footer.vue?e49253d8